import { createDocument, getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import { Input, Select } from "styled";
import axios from 'apis/axios'
import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { BiCloudDownload } from "react-icons/bi";
import { useQuery } from "react-query";
import ReactSelect from "react-select";
import { TD, TH } from "styled/table";
import exportExcel from "utils/exportExcel";
import Modal from "components/Modal";
import { Button } from 'styled'
import toast from 'react-hot-toast';
import getFormattedDate from "utils/helpers";

const getDate90DaysAgo = () => {
  const date = new Date();
  date.setDate(date.getDate() - 90);
  return date;
};

const getDateSixMonthsAgo = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 6);
  return getFormattedDate(date);
};

const POLL_INTERVAL_MS = 1500;
const PROGRESS_POLL_MAX_AGE_MS = 15 * 60 * 1000;

const toExcelDate = (value) => {
  if (!value) return "";
  const str = String(value).trim();

  const iso = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) {
    const [, yyyy, mm, dd] = iso;
    const date = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
    if (!Number.isNaN(date.getTime())) return date;
  }

  const dmy = str.match(/^(\d{2})-(\d{2})-(\d{4})/);
  if (dmy) {
    const [, dd, mm, yyyy] = dmy;
    const date = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
    if (!Number.isNaN(date.getTime())) return date;
  }

  return value;
};

// Split a tyre's total km into its ITM life and its retread lives.
// ITM = total km − retread km, so the tread buckets always reconcile to the
// total shown in "Removed Km Covered". For a never-retreaded tyre, ITM === total.
const getTreadKm = (tyreDetails) => {
  const total = parseInt(tyreDetails?.totalKillometerTravelled) || 0;
  const rtd1 = parseInt(tyreDetails?.RTD1) || 0;
  const rtd2 = parseInt(tyreDetails?.RTD2) || 0;
  const rtd3 = parseInt(tyreDetails?.RTD3) || 0;
  const rtd4 = parseInt(tyreDetails?.RTD4) || 0;
  const rtd = rtd1 + rtd2 + rtd3 + rtd4;

  return { itmKm: Math.max(0, total - rtd), rtdKm: rtd, rtd1, rtd2, rtd3, rtd4 };
};


const contractTypeOptions = [
  { value: 'All', label: 'All' },
  { value: 'CPKM', label: 'CPKM' },
  { value: 'NON CPKM', label: 'NON CPKM' }
];


const DailyTyreReplacement = () => {
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [selectedReasons, setSelectedReasons] = useState([])
  const [data, setData] = useState([])
  // const [dateFrom, setDateFrom] = useState("");
  // const [dateTo, setDateTo] = useState("");
  const [dateFrom, setDateFrom] = useState(getFormattedDate(getDateSixMonthsAgo()));
  const [dateTo, setDateTo] = useState(getFormattedDate(new Date()));
  const [kmFrom, setKmFrom] = useState("");
  const [kmTo, setKmTo] = useState("");
  const [isLoading, setIsLoading] = useState(false)
  const [fleetMap, setFleetMap] = useState({});
  const [downloading, setDownloading] = useState(false)
  const [downloadingAll, setDownloadingAll] = useState(false)
  const [downloadProgress, setDownloadProgress] = useState(null);
  const pollRef = useRef(null);
  const [contractType, setContractType] = useState("All");
  const [reportData, setReportData] = useState({})
  const monthMap = ["", "Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"]
  const debugReplacements =
   
    true;

  const buildRequestFilters = () => ({
    ...(debugReplacements ? { debugReplacements: true } : {}),
    ...(selectedFleets?.includes("all")
      ? {
        fleets: getFleetOptions()
          .filter(
            (item) => item.value !== "all" && item.value !== "clear"
          )
          .map((item) => item.value)
          .join(","),
      }
      : selectedFleets.length && {
        fleets: selectedFleets.map((fleet) => fleet).join(","),
      }),
    ...(selectedHubs?.includes("all")
      ? {
        hubs: getHubOptions()
          .filter(
            (item) => item.value !== "all" && item.value !== "clear"
          )
          .map((item) => item.value)
          .join(","),
      }
      : selectedHubs.length && {
        hubs: selectedHubs.map((hub) => hub).join(","),
      }),

      ...(!selectedReasons?.includes("all")
      ? { replacementType: selectedReasons.map((fleet) => fleet).join(","),
      }: {replacementType:""}),
    ...(contractType &&
      contractType !== "All" && {
      contractType: contractType,
    }),
    dateFrom: dateFrom || getDateSixMonthsAgo(),
    dateTo: dateTo || getFormattedDate(new Date()),
    kmFrom: kmFrom ? Number(kmFrom) : null,
    kmTo: kmTo ? Number(kmTo) : null,
  });

  const getData = async () => {
    if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
      toast.error("Both Start Date and End Date must be provided together.");
      setData([]);
      return;
    }
    setIsLoading(true);
    try {
      const dt = await createDocument(
        "/report/dailyTyreReplacement",
        buildRequestFilters()
      );

      // console.log(dt);
      if(dt.data) setData(dt);
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  const pollDownloadProgress = useCallback((requestId, startedAt) => {
    if (pollRef.current) clearInterval(pollRef.current);
    const poll = async () => {
      if (Date.now() - startedAt > PROGRESS_POLL_MAX_AGE_MS) {
        if (pollRef.current) clearInterval(pollRef.current);
        setDownloadProgress((p) => (p?.requestId === requestId ? null : p));
        return;
      }
      try {
        const res = await axios.get(
          `mail-logger/fleetstockdownloads/progress/${requestId}`
        );
        const d = res.data?.data;
        setDownloadProgress((prev) =>
          prev?.requestId === requestId
            ? {
                ...prev,
                ...d,
                progressPercent: d?.progressPercent ?? 0,
                progressMessage: d?.progressMessage ?? prev?.progressMessage,
              }
            : prev
        );
        if (d?.emailSent === true || d?.progressPercent >= 100) {
          if (pollRef.current) clearInterval(pollRef.current);
          toast.success(
            "Report sent to your email. You can also get it from the Download Section."
          );
          setTimeout(
            () =>
              setDownloadProgress((p) =>
                p?.requestId === requestId ? null : p
              ),
            2500
          );
          return;
        }
        if (d?.error) {
          if (pollRef.current) clearInterval(pollRef.current);
          toast.error(d.error || "Download failed.");
          setTimeout(
            () =>
              setDownloadProgress((p) =>
                p?.requestId === requestId ? null : p
              ),
            1500
          );
        }
      } catch {
        // keep polling on transient errors
      }
    };
    poll();
    pollRef.current = setInterval(poll, POLL_INTERVAL_MS);
  }, []);

  useEffect(() => {
    return () => {
      if (pollRef.current) clearInterval(pollRef.current);
    };
  }, []);

  const downloadAllFleetsData = async () => {
    if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
      toast.error("Both Start Date and End Date must be provided together.");
      return;
    }
    setDownloadingAll(true);
    setDownloadProgress({
      requestId: null,
      progressPercent: 0,
      progressMessage: "Initiating...",
    });
    try {
      const response = await axios({
        method: "POST",
        url: "/report/dailyTyreReplacementDownloadAll",
        data: buildRequestFilters(),
      });

      const requestId = response.data?.requestId;
      if (requestId) {
        setDownloadProgress({
          requestId,
          progressPercent: 10,
          progressMessage: "Report queued...",
        });
        pollDownloadProgress(requestId, Date.now());
        toast.success(
          response.data?.message ??
            "Your report has been queued. You will receive it in email shortly."
        );
      } else {
        setDownloadProgress(null);
        toast.success(response.data?.message ?? "Request submitted.");
      }
    } catch (err) {
      setDownloadProgress(null);
      const message =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Something went wrong while requesting the report";
      toast.error(message);
    } finally {
      setDownloadingAll(false);
    }
  };
  const getDownloadData = async () => {
    if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
      toast.error("Both Start Date and End Date must be provided together.");
      return;
    }
    setDownloading(true)
    try {
      const dt = await createDocument(
        "/report/dailyTyreReplacement",
        buildRequestFilters()
      );


      if (dt.data) {
        const monthNames = dt.months?.map(month => {
          const [year, monthNum] = month?.split("-");
          return `${monthMap[parseInt(monthNum)]} ${year}`;
        });
        let totalRow = {
          "Fleet Name": "Total",
          Total: dt.totalMap.total
        };
        dt.months.forEach((month, monthIdx) => {
          const monthKey = monthNames[monthIdx];
          totalRow[monthKey] = dt.totalMap[month] ?? 0;
        })
        
        exportExcel(
          [
            ...dt.data?.map((entry, idx) => {
              const monthWise = {};
              dt.months.map((month) => {
                monthWise[
                  `${monthMap[parseInt(month?.split("-")[1])]} ${
                    month?.split("-")[0]
                  }`
                ] = entry[month] ?? 0;
              });
              return {
                "Fleet Name": `${entry.fleetName} (${entry.fleetCity})`,
                "Fleet Code": entry.fleetCode,
                ...monthWise,
                Total: entry.total,
              };
            }),
            totalRow
            
          ],
          "daily_tyre_replacement"
        );
      }
    } catch (err) {

    }
    finally { setDownloading(false) }

  }

  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );
  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
    })
  );
  const setFleetMapData = useCallback(() => {
    let selectedFleetCodes = allFleets?.data?.map((fleet) => fleet.fleetCode);
    let selectedHubsData = [];
    if (selectedHubs?.includes("all"))
      selectedHubsData = allHubs?.data?.filter((hub) =>
        selectedFleetCodes?.includes(hub.fleetCode)
      );
    else
      selectedHubsData = allHubs?.data?.filter((hub) =>
        selectedHubs?.includes(hub._id)
      );
    const mp = {};
    selectedHubsData.map((hub) => {
      if (selectedFleetCodes?.includes(hub.fleetCode)) {
        if (mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
        mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
      }
    });

    setFleetMap({...mp});
  }, [allFleets?.data, allHubs?.data, selectedHubs])


  

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      return [
        ...selectedFleets?.length ? [{
          label: "All",
          value: "all",
        }]: [],
        ...selectedFleets?.length ? [{
          label: "Clear",
          value: "clear",
        }]: [],
        ...(selectedFleets?.includes("all") ?
          allHubs?.data?.length &&
          allHubs?.data
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            }) :
          allHubs?.data?.length &&
          allHubs?.data
            ?.filter((hub) => {
              const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                selectedFleets?.includes(fleet._id)
              );

              return selectedFleetsVal?.some(
                (fleet) => fleet.fleetCode === hub.fleetCode
              );
            })
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })),
      ];
    }
  }, [allFleets, allHubs, selectedFleets]);

  const getReplacementReasons = useCallback(() => {
    // if (replacementReasons && replacementReasons.data && replacementReasons.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        // ...replacementReasons?.data?.map((fleet) => {
        //   return {
        //     value: fleet.name,
        //     label: fleet.name,
        //   };
        // }),
        {label:  "Reuse", value: "REUSE"},
        {label:  "Casing", value: "CASING"},
        {label:  "Repair", value: "REPAIR"},
        {label:  "Scrap", value: "SCRAP"},
        {label:  "Missing", value: "MISSING"},
      ];
    // }
  }, []);

  return (
    <div>
      <div className="w-full px-8 flex gap-3 mt-3">
        <label className="w-full ">
          Select Fleets
          <ReactSelect
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: "transparent",
                minWidth: "100%",
                "&:hover": {
                  borderColor: "rgb(34 197 94)",
                },
              }),
            }}
            className="shadow-md rounded-md py-1 mb-2 "
            options={getFleetOptions()}
            value={
              selectedFleets &&
              selectedFleets?.map((fleet) => {
                return {
                  value: fleet,
                  label: getFleetOptions()?.find(
                    (item) => item?.value === fleet
                  )?.label,
                };
              })
            }
            onChange={(value) => {
              let allValues = value?.map((item) => item.value);
              if (allValues?.includes("clear")) {
                // console.log(allValues);
                setSelectedFleets([]);
                setSelectedHubs([]);
                return;
              }
              if (
                !selectedFleets?.includes("all") &&
                allValues.includes("all")
              ) {
                setSelectedFleets(["all"]);
                return;
              }
              // console.log("CLERAININEIENGs");

              if (selectedFleets.includes("all")) {
                // console.log("first");
                // console.log(getFleetOptions());
                value = value.filter((item) => item.value !== "all");
              }

              // console.log(allValues)
              // console.log({selectedFleets, value})
              let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                value?.map((item) => item.value)?.includes(fleet._id)
              );

              let selectedHubsVal = allHubs?.data?.filter((hub) =>
                selectedHubs?.map((item) => item)?.includes(hub._id)
              );

              setSelectedHubs(
                selectedHubsVal
                  ?.filter((hub) =>
                    selectedFleetsVal?.find(
                      (fleet) => fleet.fleetCode === hub.fleetCode
                    )
                  )
                  .map((hub) => hub._id)
              );

              // console.log({ allHubs, selectedHubs });

              setSelectedFleets(value.map((fleet) => fleet.value));
            }}
            name="fleets"
            isMulti={true}
          />
        </label>

        <label className="w-full ">
          Select Hubs
          <ReactSelect
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: "transparent",
                minWidth: "100%",
                "&:hover": {
                  borderColor: "rgb(34 197 94)",
                },
              }),
            }}
            className="shadow-md rounded-md py-1 mb-2 "
            options={getHubOptions()}
            value={
              selectedHubs &&
              selectedHubs?.map((hub) => {
                // console.log({ hub });
                return {
                  value: hub,
                  label: getHubOptions()?.find((item) => item.value === hub)
                    ?.label,
                };
              })
            }
            onChange={(value) => {
              const allValues = value?.map((item) => item.value);
              // console.log({ allValues });
              if (allValues.includes("clear")) {
                setSelectedHubs([]);
                return;
              }
              if (!selectedHubs?.includes("all") && allValues.includes("all")) {
                let selectedFleetCodes = allFleets?.data
                  ?.filter((fleet) => selectedFleets?.includes(fleet._id))
                  ?.map((fleet) => fleet.fleetCode);

                const selectedHubsData = allHubs?.data?.filter((hub) =>
                  selectedFleetCodes?.includes(hub.fleetCode)
                );

                const mp = fleetMap;
                selectedHubsData.map((hub) => {
                  if (selectedFleetCodes?.includes(hub.fleetCode)) {
                    if (mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                    mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
                  }
                });

                // setFleetMap(mp);
                setSelectedHubs(["all"]);
              } else {
                // console.log({ value });
                value = value.filter((value) => value.value !== "all");
                // console.log({ value });
                let selectedFleetCodes = allFleets?.data
                  ?.filter((fleet) => selectedFleets?.includes(fleet._id))
                  ?.map((fleet) => fleet.fleetCode);
                // console.log({ allValues });

                const selectedHubsData = allHubs?.data?.filter((hub) =>
                  allValues?.includes(hub._id)
                );
                // setFleetMap({});
                const mp = {};
                selectedHubsData.map((hub) => {
                  mp[hub.fleetCode] = [];
                });

                selectedHubsData.map((hub) => {
                  if (selectedFleetCodes?.includes(hub.fleetCode)) {
                    if (mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                    mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
                  }
                });

                // setFleetMap(mp);

                // console.log({value})
                // console.log({selectedFleetCodes, selectedHubsData, fleetMap})

                setSelectedHubs(value.map((hub) => hub.value));
              }
            }}
            name="hubs"
            isMulti={true}
          />
        </label>

        <label className="w-full ">
          Contract Type
          <ReactSelect
           styles={{
            control: (base, state) => ({
              ...base,
              borderColor: 'transparent',
              minWidth: '100%',
              '&:hover': {
                borderColor: 'rgb(34 197 94)',
              },
            }),
          }}
            name="contractType"
            className="shadow-md rounded-md py-1"
            value={contractTypeOptions.find(option => option.value === contractType)} // Find the option object based on the value
            onChange={(option) => {
              setContractType(option.value); // Store only the value
            }}
            options={contractTypeOptions}
          />

        </label>
      </div>
      <div className="grid grid-cols-3 lg:grid-cols-7 px-8 justify-start items-end gap-4">
        <label>
          Start Date{" "}
          <Input
            type="date"
            max={getFormattedDate()}
            name="dateFrom"
            value={dateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
          />
        </label>
        <label>
          End Date{" "}
          <Input
            type="date"
            min={dateFrom ? getFormattedDate(dateFrom) : null}
            max={getFormattedDate(new Date())}
            name="dateTo"
            value={dateTo}
            onChange={(e) => setDateTo(e.target.value)}
          />
        </label>
        <label className="py-3">
          Select Removal Reason
          <ReactSelect
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: "transparent",
                minWidth: "100%",
                "&:hover": {
                  borderColor: "rgb(34 197 94)",
                },
              }),
            }}
            className="shadow-md rounded-md py-1 mb-2"
            options={getReplacementReasons()}
            value={
              selectedReasons &&
              selectedReasons?.map((name) => {
                return {
                  value: name,
                  label: getReplacementReasons()?.find(
                    (item) => item?.value === name
                  )?.label,
                };
              })
            }
            onChange={(value) => {
              // console.log(value)
              let allValues = value?.map((item) => item.value);
              
              if (allValues?.includes("clear")) {
                // console.log(allValues);
                setSelectedReasons([]);
                return;
              }

              if (
                !selectedReasons?.includes("all") &&
                allValues.includes("all")
              ) {
                setSelectedReasons(["all"]);
                return;
              }
              // console.log("CLERAININEIENGs");

              if (selectedReasons.includes("all")) {
                // console.log("first");
                value = value.filter((item) => item.value !== "all");
              }

              setSelectedReasons(value.map((fleet) => fleet.value));
            }}
            name="rr"
            isMulti={true}
          // isMulti={selectedFleets?.includes("all") ? false : true}
          // isDisabled={selectedFleets?.includes("all") ? true : false}
          />
        </label>
        <label className="">
            KM From{" "}
            <Input
              type="number"
              value={kmFrom}
              onChange={(e) => setKmFrom(e.target.value)}
            />
          </label>
          <label>
            KM To{" "}
            <Input
              type="number"
              value={kmTo}
              onChange={(e) => setKmTo(e.target.value)}
            />
          </label>

        <div className="col-span-3 lg:col-span-2 h-14 flex gap-3 items-center flex-nowrap">
          <Button
            type="button"
            className=''
            disabled={!selectedHubs?.length}
            bgPrimary
            onClick={() => {
              setFleetMapData();
              getData()}}
          >
            Search
          </Button>
          {downloading
            ? "Downloading..."
            : selectedHubs.length !== 0 && (
              <BiCloudDownload
                className="w-12 h-12 text-green-500 hover:scale-105 cursor-pointer text-center shrink-0"
                onClick={() => {
                  getDownloadData();
                }}
              />
            )}
          {selectedHubs.length !== 0 && (
            <Button
              type="button"
              bgPrimary
              className="whitespace-nowrap"
              disabled={downloadingAll || !!downloadProgress?.requestId}
              onClick={() => {
                downloadAllFleetsData();
              }}
            >
              <BiCloudDownload className="w-5 h-5" />
              {downloadingAll || downloadProgress?.requestId
                ? "Preparing file..."
                : "Download Data (All Fleets)"}
            </Button>
          )}
        </div>
      </div>

      {downloadProgress?.requestId && (
        <div className="mx-2 lg:mx-10 mt-3 w-full max-w-md rounded-lg border border-gray-200 bg-white p-3 shadow-sm">
          <p className="mb-1 text-sm font-medium text-gray-700">
            Daily Tyre Replacement (All Fleets) – generating report
          </p>
          <div className="h-2 w-full overflow-hidden rounded-full bg-gray-200">
            <div
              className="h-full rounded-full bg-green-500 transition-all duration-300"
              style={{
                width: `${Math.min(
                  100,
                  Math.max(0, downloadProgress.progressPercent ?? 0)
                )}%`,
              }}
            />
          </div>
          <p className="mt-1 text-xs text-gray-500">
            {downloadProgress.progressMessage ?? "Please wait..."} The file will
            be emailed to you and listed under the Download Section.
          </p>
        </div>
      )}

      {isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col m-2 lg:m-10">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <TH scope="col">S.N.</TH>
                      <TH scope="col">Fleet Name</TH>
                      <TH scope="col">Fleet Code</TH>
                      {data.months?.map((month) => (
                        <TH scope="col">{monthMap[parseInt(month?.split("-")[1])]} {month?.split("-")[0]}</TH>
                      ))}
                      <TH scope="col">Total</TH>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {data &&
                      data.data &&
                      data.data?.map((entry, idx) => {
                        // console.log({entry})
                        return (
                          <ViewList
                            fleetName={entry.fleetName}
                            fleetCode={entry.fleetCode}
                            fleetCity={entry.fleetCity}
                            monthMap={monthMap}
                            data={entry}
                            months={data.months}
                            idx={idx}
                            dateFrom ={dateFrom}
                            dateTo={dateTo}
                            fleetMap={fleetMap}
                            selectedReasons={selectedReasons}
                            kmFrom={kmFrom}
                            kmTo={kmTo}
                            contractType={contractType}
                          />
                        );
                      })}
                  </tbody>

                  <tfoot>
                  {data?.data && <tr className="text-gray-600 font-semibold bg-green-100">
                    <TD></TD>
                            <TD  className="text-left">TOTAL</TD>
                            <TD  className="text-center"></TD>
                            {data?.months?.map((month) => {
                                return <TD className="text-center">
                                        {data.totalMap[month] ?? 0}
                                    </TD>
                            })}
                        <TD className="text-center">{data.totalMap.total}</TD>
                  </tr>}
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DailyTyreReplacement;

const ViewList = ({ fleetName, fleetMap, fleetCode,fleetCity, selectedReasons, data, idx, months, monthMap, dateFrom, dateTo, contractType, kmFrom, kmTo }) => {
  const [showModal, setShowModal] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [fleet, setFleet] = useState("")
  const [isLoading, setIsLoading] = useState(true)
  const [modalQueryProp, setModalQueryProp] = useState(null);

  console.log({ 'fleetCity':fleetCity })
  const getModalData = async (modalQueryProp,fleetId,download) => {
    if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
      toast.error("Both Start Date and End Date must be provided together.");
      return;
    }
    setShowModal(true)
    if (modalQueryProp) {
      if(!download) setIsLoading(true);
      else setDownloading(true)
      const dt = await createDocument("/report/dailyTyreReplacementModalInfo",{
        ...(fleetMap[modalQueryProp.fleetCode]?.length && {
          hubs: fleetMap[modalQueryProp.fleetCode].map((hub) => hub).join(","),
        }),
        ...(!selectedReasons?.includes("all")
        ? { replacementType: selectedReasons.map((fleet) => fleet).join(","),
        }: {replacementType:""}),
        monthYear:modalQueryProp?.month,
        ...(contractType &&
          contractType !== "All" && {
          contractType: contractType,
        }),
        kmFrom: kmFrom ? Number(kmFrom) : null,
        kmTo: kmTo ? Number(kmTo) : null,
        dateFrom: dateFrom || getDateSixMonthsAgo(),
        dateTo: dateTo || getFormattedDate(new Date()),
        download,
      })
      setModalQueryProp(modalQueryProp);
      if(download) {setDownloading(false);
        return dt};
      setModalData(dt);
    }
    setIsLoading(false);
  }

  const modalHandler = useCallback(
    (data) => {
      if (data) {
        getModalData(data);
        // setShowModal(true);
      } else {
        // setShowModal(false);
        // setModalData([]);
      }
    },
    [showModal, modalData]
  );

  const downloadDiv = (fleetId, fleetName, fleetCode, month, data, title) => {
    return data ? (<div className="flex gap-2 items-center justify-center">
      <span
        className="hover:text-green-500 cursor-pointer"
        onClick={() => { modalHandler({data: data, fleetId, fleetCode, month, fleetName: fleetName, title}); setFleet(fleetName) }}
        >
        {data}
      </span>
    </div>) : (
        <div className="flex gap-2 items-center justify-center">
          <span
            // className="hover:text-green-500 cursor-pointer"
          >
            0
          </span>
        </div>
      )
  }

  return (
    <Fragment>
      {showModal && (
        <Modal
          handleClick={() => setShowModal(false)}
          title={modalQueryProp?.title}
          className="max-w-2xl"
        >
          {/* <h1>This is the modal</h1> */}
          {isLoading ? <Spinner/> : <><h1 className="w-full flex justify-end text-end px-2 my-1">

            <Button
              disabled={downloading}
              onClick={async () => {
                let downloadData = await getModalData(modalQueryProp, modalQueryProp?.fleetId, true)
                console.log('downloadData--',downloadData);
                exportExcel(
                  downloadData?.data?.map((item) => {
                  const { itmKm, rtdKm, rtd1, rtd2, rtd3, rtd4 } = getTreadKm(item.prevTyreDetails);
                  return {
                    "Registration Number": item.registrationNumber,
                    "Date": toExcelDate(item?.inspectionDate),
                    "Contract Type": item.contractType,
                    "Application Type": item.applicationType,
                    "Fleet": `${fleetName} (${fleetCity})`,
                    "Hub Name": item.hubName,
                    "Removed Stencil Number": item.prevTyreDetails?.stencilNo,
                    "Removed Tyre NSD": item.prevTyreDetails?.averageNSD ? parseFloat(item.prevTyreDetails.averageNSD).toFixed(2):null,
                    "Removed Tyre Brand Name": item.prevTyreDetails?.brand,
                    "Removed Tyre Size": item.prevTyreDetails?.tyreSize,
                    "Removed Km Covered": item.prevTyreDetails?.totalKillometerTravelled ,
                    "Removed Tyre ITM Km": itmKm,
                    "Removed Tyre RTD Km": rtdKm,
                    "Removed Tyre RTD1 Km": rtd1,
                    "Removed Tyre RTD2 Km": rtd2,
                    "Removed Tyre RTD3 Km": rtd3,
                    "Removed Tyre RTD4 Km": rtd4,
                    "Removed Tyre Manaufacturer Name": item.prevTyreDetails?.companyName,
                    "Removed Tyre Life": item.prevTyreDetails?.tyreType ?? "ITM",
                    "Removed Tyre Remark": item.removedTyreRemark || "",
                    "Cause of Removal Tyre": item.prevTyreDetails?.replacementType ?? item.currTyreDetails?.replacementType,
                    "Scrap Reason": item.prevTyreDetails?.scrapReason ? item.prevTyreDetails?.scrapReason : "N/A",
                    "Fitted Stencil Number": item.currTyreDetails?.stencilNo,
                    "Fitted Tyre NSD": item.currTyreDetails?.averageNSD ? parseFloat(item.currTyreDetails.averageNSD).toFixed(2) : null,
                    "Fitted Tyre Brand": item.currTyreDetails?.brand,
                    "Fitted Tyre Last Remark": item.fittedTyreLastRemark || "",
                    "Fitted Tyre Position": item.position,
                    "Fitted Tyre Manufacturer Name": item.currTyreDetails?.companyName,
                    "Fitted Tyre Location":item.fittedTyreLocation,
                    "Fitted Tyre Remark": item.fittedTyreRemark,
                  };
                  }),
                  modalQueryProp?.title?.split(" ")?.join("_") + "_Data"
                );
                 
              }}
              className=" text-blue-500 hover:scale-105 cursor-pointer text-right"
            >
              {downloading ? "Downloading" : "Download"}
            </Button>
            </h1>
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <TH scope="col">S.N.</TH>
                <TH scope="col">Vehicle Number</TH>
                <TH scope="col">Inspection Date</TH>
                <TH scope="col">Cause of Removal</TH>
                {/* <TH scope="col"> totalKillometerTravelled</TH> */}
                <TH scope="col"> Contract Type</TH>
                <TH scope="col"> Application Type</TH>
                <TH scope="col"> Position</TH>
                <TH scope="col"> Removed Stencil Number</TH>
                <TH scope="col">New Stencil Number</TH>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {modalData &&
                modalData?.data?.length > 0 &&
                modalData?.data?.map((vehicle, index) => (
                  <tr>
                    <TD>{index + 1}</TD>
                    <TD>{vehicle.registrationNumber}</TD>
                    <TD>{vehicle.inspectionDate}</TD>
                    <TD>{vehicle.prevTyreDetails?.replacementType ?? vehicle.currTyreDetails?.replacementType}</TD>
                    {/* <TD>{vehicle.prevTyreDetails?.totalKillometerTravelled}</TD> */}
                    <TD>{vehicle?.contractType}</TD>
                    <TD>{vehicle?.applicationType}</TD>
                    <TD>{vehicle.position}</TD>
                    <TD>{vehicle.prev}</TD>
                    <TD>{vehicle.curr}</TD>
                  </tr>
                ))}
            </tbody>
          </table> </>}
        </Modal>
      )}
      <tr className={`${idx % 2 !== 0 && "bg-gray-100"}`}>
        <TD>{idx + 1}</TD>
        <TD>{fleetName} ({fleetCity})</TD>
        <TD>{fleetCode}</TD>
        {months.map(month => {
          return <TD>
            {downloadDiv(data.fleetId, fleetName, fleetCode, month, data[month], "Daily Tyre Replacement " + fleetName + " (" + (fleetCity ?? "-") + ") " + (monthMap[parseInt(month?.split("-")[1])] + "-" + month?.split("-")[0]) )}
          </TD>
        })}
        <TD>
        {downloadDiv(data.fleetId, fleetName, fleetCode, '', data.total, "Daily Tyre Replacement " + fleetName + " (" + (fleetCity ?? "-") + ") " + ('total') )}
        </TD>
      </tr>
    </Fragment>
  );
}